import React from "react";
import { makeStyles } from '@mui/styles';
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)'
    }
  },
  paper: {
    backgroundColor: "#ffffff",
    padding: theme.spacing(2, 4, 3),
    borderRadius: "15px",
    width: "380px",
    position: 'relative',
    outline: 'none',
    boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12)'
  }
}));

export default function TransitionsModal(props) {
  const classes = useStyles();
  let _reload = true;
  const {
    workFlowExamMsg,
     _setWorkFlowExamMsg,
    workflowContext,
    showFinishModal,
     _onSubmit,
    result,
    showResult,
    showscore,
    queryResult,
    setResumeFlag,
    submissionFailure,
    examDetail,
    // examId, setWindowSwitch, setTestData, windowSwitchCount, testData
  } = props;

  // Workflow message logic (score-based messages cannot be shown here since
  // result processing is async — show what we know at submission time):
  //   • Single instruction: same message for all scores → show it immediately.
  //   • Multiple instructions: score-dependent → show a level-specific acknowledgement;
  //     the accurate message appears on the dashboard once processing completes.
  const resolvedWorkflowMsg = (() => {
    if (!workflowContext) return null;
    const { levelName, workflowName, instructions = [] } = workflowContext;
    const wfLabel   = workflowName || 'Workflow';
    const lvlLabel  = levelName   || '';
    if (instructions.length === 1 && instructions[0].message) {
      return instructions[0].message;
    }
    // Multiple score ranges — acknowledge submission without guessing the outcome
    return lvlLabel
      ? `${wfLabel} — ${lvlLabel} submitted successfully. Your result will be updated on the dashboard.`
      : `${wfLabel} test submitted successfully. Your result will be updated on the dashboard.`;
  })();

  // onWindowReload(examId,examDetail,setWindowSwitch,setTestData,windowSwitchCount,testData)

  const handleClose = async () => {
    await setResumeFlag(false);
    // window.onbeforeunload = (event) =>{
    //   event.preventDefault();
    // }
    window.onbeforeunload = function () {
      return null; // return null to avoid pop up
    };
    // onSubmit('010');
    // reload = false
    window.location.reload("/dashboard");
  };

  // window.onbeforeunload = function (e) {
  //   e.preventDefault();
  // }

  window.onbeforeunload = function () {
    return null; // return null to avoid pop up
  };

  // useEffect(() => {
  //   if (reload) {
  //     const unloadCallback = (event) => {
  //       event.preventDefault();
  //       event.returnValue = "";
  //       return "";
  //     };
  //     window.addEventListener("beforeunload", unloadCallback);
  //     return () => window.removeEventListener("beforeunload", unloadCallback);
  //   }
  // }, []);
  return (
    <div>
      <Modal
        disableEnforceFocus={true}
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={showFinishModal}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      
      >
        <Fade in={showFinishModal}>
          {/* <div className={classes.paper}> */}
          <div className={classes.paper} style={{ textAlign: "justify" }}>
            <div style={{ textAlign: "center" }}>
              <h3 id="transition-modal-title" style={{ color: "#6f2981", marginBottom: "30px" }}>
                {showscore === false && queryResult === false && workFlowExamMsg === "" ? "System Status" : "System Warning"}
              </h3>
            </div>
            {/* <p
              id="transition-modal-description"
              style={{ textAlign: "justify" }}
            >
              Your {examDetail[0].test_type === "7" || examDetail[0].test_type === "8" ? "Survey" : "Test"} has been Submitted. Please attempt Pending {examDetail[0].test_type === "7" || examDetail[0].test_type === "8" ? "Surveys" : "Tests"}.
              <br />
              <br />
              Thanking you,
              <br />
              Support, AssessHub.
            </p> */}
            {showscore ? (
              result !== undefined && result !== null && showResult ? (
                <div className="form-group" style={{ textAlign: "center" }}>
                  <p style={{ fontWeight: "bold" }} dangerouslySetInnerHTML={{ __html: result }}></p>
                  <ul className="list-inline">
                    <li>
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a href="#" className="btn btn-blue" style={{ borderRadius: "10px" }} onClick={() => handleClose()}>
                        <strong>Close</strong>
                      </a>
                    </li>
                  </ul>
                </div>
              ) : (
                <>
                  <p>
                    Your result is being processed. Please{" "}
                    <span style={{ color: "red" }}>
                      <strong>DO NOT </strong>
                    </span>
                    refresh this page or close the browser, else your test result will be considered{" "}
                    <span style={{ color: "red" }}>
                      <strong>INVALID.</strong>
                    </span>
                  </p>
                </>
              )
            ) : (
              <div className="form-group" style={{ textAlign: "center" }}>
                {queryResult ? (
                  <>
                    <p>
                      Your result is being processed. Please{" "}
                      <span style={{ color: "red" }}>
                        <strong>DO NOT </strong>
                      </span>
                      refresh this page or close the browser, else your test result will be considered{" "}
                      <span style={{ color: "red" }}>
                        <strong>INVALID.</strong>
                      </span>
                    </p>
                  </>
                ) : (
                  <>
                    {submissionFailure ? (
                      <>
                        <p id="transition-modal-description" style={{ textAlign: "justify" }}>
                          {resolvedWorkflowMsg ? (
                            resolvedWorkflowMsg
                          ) : (
                            <>
                              Your test has
                              <span style={{ color: "red" }}>
                                <strong> NOT </strong>
                              </span>
                              been submitted. Please check your internet connection.
                              <br />
                              <br />
                              Your test will be automatically submitted once your connection is restored and you log back in.
                              <br />
                              <br />
                              Thanking you,
                              <br />
                              Support, AssessHub.
                            </>
                          )}
                        </p>
                        <ul className="list-inline">
                          <li>
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a href="#" className="btn btn-blue" style={{ borderRadius: "10px" }} onClick={handleClose}>
                              <strong>Close</strong>
                            </a>
                          </li>
                        </ul>
                      </>
                    ) : (
                      <>
                        <p id="transition-modal-description" style={{ textAlign: "justify" }}>
                          {resolvedWorkflowMsg ? resolvedWorkflowMsg : <>Your {examDetail[0].test_type === "7" || examDetail[0].test_type === "8" ? "survey" : "test"} has been submitted. Please attempt pending {examDetail[0].test_type === "7" || examDetail[0].test_type === "8" ? "surveys" : "tests"} if any.</>}
                          <br />
                          <br />
                          Thanking you,
                          <br />
                          Support, AssessHub.
                        </p>
                        <ul className="list-inline">
                          <li>
                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                            <a href="#" className="btn btn-blue" style={{ borderRadius: "10px" }} onClick={handleClose}>
                              <strong>Close</strong>
                            </a>
                          </li>
                        </ul>
                      </>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
